import React from 'react';

import { ContentRenderer } from '@jetshop/ui/ContentRenderer';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import { styled } from 'linaria/react';

import ContentElements from '../ContentElements';
import MaxWidth from '../Layout/MaxWidth';

const Content = styled('div')`
   padding-bottom: 3rem;

   h1,
   h2,
   h3,
   h4,
   h5 {
      margin-bottom: 0.3ch;
   }

   p + h1,
   p + h2,
   p + h3,
   p + h4,
   p + h5 {
      margin-top: 4ch;
   }

   p {
      margin-bottom: 2ch;
   }
`;

const Wrapper = styled(MaxWidth)`
   max-width: 45rem;
   padding-top: 3rem;
`;

const components = {
   HTML: props => {
      return (
         <Content
            dangerouslySetInnerHTML={{
               __html: props?.html?.value,
            }}
         />
      );
   },
   ...ContentElements,
};

function ContentPage(props) {
   const { page } = props;

   return (
      <Wrapper>
         {page ? (
            <>
               {page.data ? (
                  <>
                     <ContentRenderer
                        items={page.data.items}
                        components={components}
                     />
                  </>
               ) : (
                  <Content
                     dangerouslySetInnerHTML={{
                        __html: page?.content,
                     }}
                  />
               )}
            </>
         ) : (
            <LoadingLine
               heightPx={14}
               widthRem={30}
               randomizeWidthBy={10}
               count={10}
               style={{
                  marginBottom: '12px',
               }}
            />
         )}
      </Wrapper>
   );
}

export default ContentPage;
